import React from "react";

import { Input as DefaultInput, Flex, Textarea } from "@olist/design-system";

import { Helper, Label } from "./styles";

interface IInputProps {
  label: string;
  name: string;
  placeholder: string;
  required?: boolean;
  helper?: string;
  textarea?: boolean;
  onChange?: (...args: any) => void;
  value?: any;
}

export function Input({
  helper,
  label,
  name,
  textarea,
  ...props
}: IInputProps) {
  return (
    <Flex flexDirection="column">
      <Label htmlFor={name}>{label}</Label>
      {textarea ? (
        <Textarea
          id={name}
          maxLength={80}
          name={name}
          rows={6}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          {...props}
        />
      ) : (
        <DefaultInput
          id={name}
          maxLength={80}
          name={name}
          size={20}
          type="text"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          {...props}
        />
      )}
      {helper && <Helper>{helper}</Helper>}
    </Flex>
  );
}
